// extracted by mini-css-extract-plugin
export default {"wrapperSelect":"CourseSelection_wrapperSelect__lPE3L","select":"CourseSelection_select__1MfUN"};